import { FC } from 'react';
import { AllieGoBackLink } from '../GoBackLink';
import { AlliePageTitle } from '../PageTitle';
import { AllieBackButton, AllieCard } from '../../../components';
import { DataContent, DataContentProps as ContentProps } from './components/Contents/DataContent';
import { AllieComments, AllieCommentsProps } from '../Comments';
import { AllieBackArrow } from '../../../styling/icons';
import { AllieChecklist, AllieChecklistProps } from '../Checklist';
import './DetailLayout.mobile.css';

const namespace = 'allie-detail-layout';

export interface DetailLayoutMobileProps {
  title: string;
  contents: ContentProps[];
  checklistProps?: AllieChecklistProps;
  commentsProps?: AllieCommentsProps;
  goBackLink: string;
  isNav?: boolean;
  onBackClick?: () => void;
}

export type DataContentProps = ContentProps;

export const AllieDetailLayoutMobile: FC<DetailLayoutMobileProps> = ({
  title,
  contents,
  commentsProps,
  checklistProps,
  goBackLink,
  isNav,
  onBackClick,
}) => {
  return (
    <main className={namespace}>
      <header className="header">
        {isNav ? (
          <AllieBackButton
            defaultHref={goBackLink}
            icon={AllieBackArrow}
            onclick={onBackClick}
          />
        ) : (
          <AllieGoBackLink href={goBackLink} />
        )}
        <div>
          <AlliePageTitle>{title}</AlliePageTitle>
        </div>
      </header>
      <div className="content">
        <AllieCard
          content={{
            children: (
              <article className="card-content">
                {contents.map((content, index) => (
                  <DataContent key={index} {...content} />
                ))}
              </article>
            ),
          }}
        />
        {checklistProps && (
          <AllieCard
            content={{
              children: (
                <article className="card-content">
                  <AllieChecklist {...checklistProps} />
                </article>
              ),
            }}
          />
        )}
        {commentsProps && (
          <AllieCard
            content={{
              children: (
                <article className="card-content">
                  <AllieComments {...commentsProps} />
                </article>
              ),
            }}
          />
        )}
      </div>
    </main>
  );
};
